import React from "react"
import {
  AspectRatio,
  Box,
  Container,
  Flex,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import placeholderImage from "assets/images/placeholder-image.svg"
import WebsiteHeader from "../WebsiteHeader"

/** Wide template hero ratio (1140×500) so preview matches actual template when resizing */
const WIDE_HERO_RATIO = 1140 / 500

const Classic = ({
  buttonClick,
  actionText,
  title,
  coverImageUrl,
  rsvpButtonColor,
}: {
  buttonClick: (() => void) | null
  actionText: string
  title: string
  coverImageUrl: string
  rsvpButtonColor: string
}) => (
  <Container maxW="1140px" p={0}>
    <AspectRatio ratio={WIDE_HERO_RATIO} width="100%">
      <Box
        bgImage={`url("${coverImageUrl || placeholderImage}")`}
        bgColor={coverImageUrl ? undefined : "gray.200"}
        bgPosition="center"
        bgSize="cover"
        width="100%"
        height="100%"
        pos="relative"
      >
        {!coverImageUrl && (
          <Flex pos="absolute" inset={0} align="center" justify="center" pb={20}>
            <Icon icon="email-block-image" size={36} color="gray.300" />
          </Flex>
        )}
        <Box
          pos="absolute"
          bottom={0}
          left={0}
          width="100%"
          minHeight="80px"
          padding="22px"
          color="white"
        >
          <Box
            bgColor="black"
            opacity="0.5"
            h="100%"
            w="100%"
            bottom={0}
            left={0}
            pos="absolute"
          />
          <Flex px={5}>
            <WebsiteHeader
              title={title}
              buttonClick={buttonClick}
              actionText={actionText}
              rsvpButtonColor={rsvpButtonColor}
            />
          </Flex>
        </Box>
      </Box>
    </AspectRatio>
  </Container>
)

export default Classic
